import { TFunction } from 'react-i18next';

import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

import { TipShareShift } from '../../types';

interface ShiftActionsMenuProps {
  shift: TipShareShift;
  shiftId: string;
  anchorEl: HTMLElement | null;
  isOpen: boolean;
  onOpen: (event: React.MouseEvent<HTMLElement>) => void;
  onClose: () => void;
  onEdit: (shift: TipShareShift) => void;
  onDelete: (shift: TipShareShift) => void;
  t: TFunction<'translation', undefined>;
}

function ShiftActionsMenu({
  shift,
  shiftId,
  anchorEl,
  isOpen,
  onOpen,
  onClose,
  onEdit,
  onDelete,
  t,
}: Readonly<ShiftActionsMenuProps>) {
  const handleEditClick = () => {
    onEdit(shift);
    onClose();
  };

  const handleDeleteClick = () => {
    onDelete(shift);
    onClose();
  };

  return (
    <>
      <IconButton
        size='small'
        onClick={(e) => {
          e.stopPropagation();
          onOpen(e);
        }}
        data-testid={`shift-menu-button-${shiftId}`}
      >
        <MoreVertIcon fontSize='small' />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={isOpen}
        onClose={onClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <MenuItem onClick={handleEditClick} data-testid={`editShiftMenuItem-${shiftId}`}>
          <EditIcon fontSize='small' sx={{ mr: 1 }} />
          {t('labor.tipShareShifts.actions.edit')}
        </MenuItem>
        <MenuItem
          onClick={handleDeleteClick}
          data-testid={`deleteShiftMenuItem-${shiftId}`}
          sx={{ color: 'text.primary' }}
        >
          <DeleteIcon fontSize='small' sx={{ mr: 1, color: 'inherit' }} />
          {t('labor.tipShareShifts.actions.delete')}
        </MenuItem>
      </Menu>
    </>
  );
}

export default ShiftActionsMenu;
